module.exports = __webpack_public_path__ + "static/media/book.acf7e948.svg";